import { useNotification } from '@gohighlevel/ghl-ui';
export function useNotify() {
    const notification = useNotification();
    function sendNotification({ title, description, type }) {
        notification.create({
            title: title,
            description: description,
            duration: 3000,
            type: type || 'default',
        });
    }
    return {
        sendNotification,
    };
}
